import React, { useEffect, useRef, useState } from 'react';

export function LoadingSheet({ isVisible, message = "Обработка запроса..." }) {
    const sheetRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);

    useEffect(() => {
        if (isVisible) {
            setIsOpen(true);
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            setIsOpen(false);
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    // Запрещаем закрытие свайпом
    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null || !sheetRef.current) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        // Небольшое движение вниз разрешаем, но не закрываем
        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);
            const maxTranslate = window.innerHeight * 0.3;
            const translateY = Math.min(diff, maxTranslate);
            sheetRef.current.style.transform = `translateY(${translateY}px)`;
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        // Возвращаем шторку на место
        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null || !sheetRef.current) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);
                const maxTranslate = window.innerHeight * 0.3;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        };

        const handleMouseUp = () => {
            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    if (!isVisible) return null;

    return (
        <div className="confirmation-sheet-wrapper visible">
            <div className="sheet-overlay" />
            <div
                ref={sheetRef}
                className="confirmation-sheet load"
                style={{pointerEvents: 'none',
            paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingTop: '12px'
            }}
            >
                <div className="sheet-content" style={{ gap: '16px' }}>
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" style={{ width: '32px', height: '3px' }} />
                    </div>

                    <div className="icon-placeholder">
                        <div className="icon-circle" style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: 'rgba(50, 215, 85, 0.1)',
                            border: '1px solid rgba(50, 215, 85, 0.3)'
                        }}>
                            <div className="loading-spinner-small" style={{
                                width: '24px',
                                height: '24px',
                                border: '2px solid rgba(50, 215, 85, 0.2)',
                                borderTopColor: '#32d755',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }} />
                        </div>
                    </div>

                    <h3 className="sheet-title" style={{ fontSize: '18px', margin: '0', textAlign: 'center' }}>
                        {message}
                    </h3>

                    <div style={{ textAlign: 'center' }}>
                        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px', margin: 0 }}>
                            Пожалуйста, подождите
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}